export const APP_TYPES = ['Dashboard', 'Prototype', 'Internal tool', 'Automation', 'Slack bot'] as const;
